import Header from "./header/header";
import PostGrid from "./component/gridShow";
import Medsos from "./component/medSos";
import PromoPage from "./lib/promo";
import Footer from "./lib/footer";
import TrendingDestinations from "./lib/trending";
import Testimonials from "./lib/testimonial";


function App() {
  return (
    <section>
      <Header />
      <PromoPage />
      <PostGrid />
      <TrendingDestinations />
      <Medsos />
      <Testimonials />
      <Footer />

      <a className="fixed bottom-4 right-4 bg-green-500 text-white p-4 rounded-full shadow-lg hover:bg-green-300 transition duration-300 z-30"
        href="https://wa.me/6281294539788?text=Halo%2C%20saya%20tertarik%20dengan%20layanan%20Anda" target="_blank" rel="noopener noreferrer">
        <img src="https://img.icons8.com/color/30/000000/whatsapp--v1.png" alt="WhatsApp Chat" />
      </a>
    </section>

  );
}

export default App;
